const genders = [
    {
        "label": "Masculino",
        "value": "male"
    },
    {
        "label": "Feminino",
        "value": "female"
    },
    {
        "label": "Homem transgênero",
        "value": "transgender_male"
    },
    {
        "label": "Mulher transgênero",
        "value": "transgender_female"
    },
    {
        "label": "Homem Transexual",
        "value": "transsex_male"
    },
    {
        "label": "Mulher Transexual",
        "value": "transsex_female"
    },
    {
        "label": "Não soube responder",
        "value": "unknown"
    },
    {
        "label": "Preferiu não responder",
        "value": "not_anwswered"
    },
    {
        "label": "Outros",
        "value": "other"
    }
]

export {genders}